import { render, staticRenderFns } from "./modifyPwd.vue?vue&type=template&id=57adbaec"
import script from "./modifyPwd.vue?vue&type=script&lang=js"
export * from "./modifyPwd.vue?vue&type=script&lang=js"
import style0 from "./modifyPwd.vue?vue&type=style&index=0&id=57adbaec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports